import classNames from 'classnames';
import React from 'react';

const statuses = [{
  title: 'badge.badge-primary',
  className: 'badge badge-primary',
  text: 'primary'
}, {
  title: 'badge.badge-secondary',
  className: 'badge badge-secondary',
  text: 'secondary'
}, {
  title: 'badge.badge-success',
  className: 'badge badge-success',
  text: 'success'
}, {
  title: 'badge.badge-warning',
  className: 'badge badge-warning',
  text: 'warning'
}, {
  title: 'badge.badge-danger',
  className: 'badge badge-danger',
  text: 'danger'
}, {
  title: 'badge.badge-info',
  className: 'badge badge-info',
  text: 'info'
}, {
  title: 'badge.badge-dark',
  className: 'badge badge-dark',
  text: 'dark'
}, {
  title: 'badge.badge-light',
  className: 'badge badge-light',
  text: 'light'
}, {
  title: 'badge.badge-dark.number',
  className: 'badge badge-dark',
  text: '707'
}, {
  title: 'badge.badge-light.number',
  className: 'badge badge-light',
  text: '707'
}, {
  title: 'badge.badge-success.icon',
  className: 'badge badge-success icon',
  text: <i className="fal fa-check"></i>
}, {
  title: 'badge.badge-danger.icon',
  className: 'badge badge-danger icon',
  text: <i className="fal fa-times"></i>
}];

const Badges = () => (<div className="styles-section row" id="badges">
  <div className='main-page-title col-12'>
    <h3>Badges</h3>
  </div>
  <div className='home-page-content col-sm-12'>
    <h6>Statuses</h6>
    {
      statuses.map(badge => (
        <div key={badge.title} className={classNames(badge.className, "mr-3")}>{badge.text}</div>
      ))
    }
  </div>

</div>);

export default Badges;